/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FileDetail',
  components: {},
  props: {},
  data: function data() {
    return {
      ApproverName: '',
      authorityName: '',
      fileopen: '',
      fileinvalid: '否',
      filepsd: '',
      filetime: '',
      inductiondate: '2',
      close: 0,
      jobnum: '',
      nation: '',
      idcard: '',
      tel: '',
      education: '',
      native: '',
      address: '',
      btnShow: true,
      fromName: '',
      depNameList: '',
      fromPath: '',
      backdepId: ''
    };
  },
  computed: {},
  watch: {},
  created: function created() {
    this.depNameList = this.$route.query.depNameList;
    this.fromPath = this.$route.query.fromPath;
    this.backdepId = this.$route.query.currentDepId;
  },
  mounted: function mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.fileDetailback, false);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    //在next中写处理函数
    next(function (vm) {
      return vm.wherefrom(from.name);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.fileDetailback, false);
  },
  methods: {
    wherefrom: function wherefrom(name) {
      // 我的  组织架构部门  公司直属
      if (name != 'My') {
        this.fromName = name;
        this.btnShow = true;
      } else {
        this.fromName = 'My';
        this.btnShow = false;
      }
    },
    fileDetailback: function fileDetailback() {
      //不是从我的进入该页面
      if (this.fromName == 'organizationList') {
        var depNameList = JSON.stringify(this.depNameList);
        this.$router.push({
          path: '/organizationList',
          query: {
            depNameList: depNameList,
            backdepId: this.backdepId
          }
        });
      } else if (this.fromName == 'fileList') {
        this.$router.push({
          path: '/fileList'
        });
      } else {
        this.$router.push({
          path: '/My'
        });
      }
    },
    havemoreclick: function havemoreclick() {
      if (this.close == 0) {
        this.close = 1;
      } else {
        this.close = 0;
      }
    }
  }
};